import { useState, useCallback } from "react"
import { useParams } from "react-router-dom"

export const useLocalStorage = () => {
  const { uuid } = useParams()
  const [localStorageData, setLocalStorageDataState] = useState<any>(
    localStorage.getItem(String(uuid))
      ? JSON.parse(localStorage.getItem(String(uuid)) || "")
      : null
  )

  const setLocalStorageData = useCallback((data: any) => {
    setLocalStorageDataState(data)
    localStorage.setItem(String(uuid), JSON.stringify(data))
  }, [uuid])

  return { localStorageData, setLocalStorageData }
}
